import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { getDictionary } from '../../assets/redux/DictionaryRedux';
import { useSelector } from 'react-redux';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
interface Iprops {
    openDialog: boolean,
    closeModal: Function,
}
export default function ConfirmDialogSineOut(props: Iprops) {
    const [open, setOpen] = React.useState(false);
    const dic = useSelector((state: any) => getDictionary(state.DicRedux));

    const handleClose = (value: boolean) => {

        setOpen(false);
        props.closeModal(value)
    };
    useEffect(() => {

        setOpen(props.openDialog);
    }, [props.openDialog])
    return (

        <Dialog
            open={open}
            onClose={e => handleClose(false)}
            fullWidth
          
        >
            <DialogTitle >{dic.signOut}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {dic.signOutText}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={e => handleClose(true)} color="secondary">
                    {dic.confirm}
                </Button>
                <Button onClick={e => handleClose(false)} color="primary" autoFocus>
                    {dic.cancel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}